<template>
    <nav>
        <div class="content-block text-center survey-start-screen rounded-xxl" 
            :class="{ 'pa-8': !mobileOverride(), 'pa-4' : mobileOverride(), 'mt-16': mobile() }"
            :style="{ 'background-color': color, 'margin-bottom': mobile() ? started || role == 'booster' ? '120px' : '89px' : '',  }">  
 
            <div>
                <v-row
                    align="center"
                    justify="center"
                    no-gutters
                >
                    <v-col cols="12">
                        <p class="start-screen-title text-h5 font-weight-bold no-break" v-html="title"></p>
                     </v-col>
                    <v-col cols="12" class="mt-3">
                        <p class="start-screen-description text-subtitle-2 font-weight-regular greytext--text no-break" v-html="description"></p>
                    </v-col>
                    <v-col cols="12" class="mt-5 mb-3">
                        <div class="survey-question-image-editor">
                            <img v-if="imageDisplay != null" :src="imageDisplay" :path="image" class="custom-image large">
                            <img v-else src="/assets/editor_images/artboard1.png" class="custom-image large">
                        </div>
                    </v-col>
                    <v-col v-if="role == 'booster'" cols="12" :sm="preview ? 12 : 6" :md="preview ? 12 : 6" lg = "6" class="mt-0" align="center" justify="center">
                        <div v-if="anonymous" style="width:180px;" class="mb-3 text-left survey-user">
                            <v-text-field dense outlined disabled class="rounded-lg pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="$t('surveyStartAnonymousPlaceholder')" />
                        </div>
                        <div v-else class="mb-3 text-left survey-user">
                            <span class="text-caption greytext--text pl-3">{{ $t('answerAs') }}</span>
                            <v-text-field dense outlined disabled class="rounded-xxl pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="name" />
                        </div>
                        <v-btn
                            data-testid="start-button"
                            type="submit"
                            color="accent"
                            min-width="220"
                            dark
                            elevation="0"
                            class="rounded-xxl text-none px-4 white--text disable-events"
                        >
                            {{ $t('surveyStart') }}
                        </v-btn>
                    </v-col>
                    <v-col v-else cols="12" sm="6"  class="mt-0" align="center" justify="center" >
                        <div v-if="anonymous" style="width:180px;" class="mb-3 text-left survey-user" >
                            <v-text-field data-testid="anonymous-discription" dense outlined disabled class="rounded-lg pa-0 ma-0 text-body-2 mx-auto" :hide-details="true" :placeholder="$t('surveyStartAnonymousPlaceholder')" />
                        </div>
                        <div v-else class="mb-3 text-left survey-user"  data-testid="participant-input-field">
                            <span class="text-caption greytext--text pl-3">{{ $t('answerAs') }}</span>
                            <v-text-field dense outlined :disabled="started" class="rounded-xxl pa-0 ma-0 text-body-2 mx-auto" hide-details="auto" v-model="name" :rules="nameRules"/>
                        </div>
                        
                        <v-btn
                            data-testid="start-button"
                            type="submit"
                            color="accent"
                            min-width="220"
                            elevation="0"
                            class="rounded-xxl text-none px-4 white--text"
                            @click="startSurvey"
                            :disabled="started"
                            
                        >
                            {{ $t('surveyStart') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </nav>
</template>
<script>
import { repeatedMethodsMixin } from '../../../../mixins/repeatedMethodsMixin'
import { ruleRequired } from '../../../../rules/formRules.js';

export default {
    props: {
        anonymous: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        imageDisplay: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: '#FFFFFF'
        },
        role: {
            type: String,
            default: 'booster'
        },
        started: {
            type: Boolean,
            default: false
        },
        preview: {
            type: Boolean,
            default: false
        },
    },
    components: {
    },

    mixins: [repeatedMethodsMixin],

    data(){
        return{
            name: localStorage.user ? JSON.parse(localStorage.user).first_name + " " + JSON.parse(localStorage.user).last_name : '',
            nameRules: ruleRequired('labelName'),
        }
    },
    methods: {
        startSurvey(){
            if(this.anonymous){
                this.$emit('startSurvey', '')
            }else{
                if(this.name.trim() != ''){
                    this.$emit('startSurvey', this.name)
                }
            }
        },
        mobileOverride(){
            if(this.screen == 'mobile-view'){
                return true;
            }else{
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            }
        },
    }
}
</script>